import Route from '@ember/routing/route'
import { service } from '@ember/service'
import type { NormalizedInterval } from 'date-fns'
import RSVP from 'rsvp'
import type ReportingUiScopeRoute from 'teacher-ui-client/reporting/ui-scope/route'
import type { StudentsScope } from 'teacher-ui-client/reporting/ui-scope/utils'
import type StudentEventsService from 'teacher-ui-client/services/student-events'

export default class extends Route {
  @service studentEvents!: StudentEventsService

  async model() {
    const { uiScope, scopedData, period } = this.modelFor('reporting.ui-scope') as ModelFor<ReportingUiScopeRoute>

    const scopedStudents = scopedData.students
    const statsScope: StudentsScope = { scope: 'students', ids: scopedStudents.map((s) => s.id) }

    const product: LegacyProductRe = 're'
    const stats = await this.makeStatsRequests(product, statsScope, period)

    return {
      product,
      uiScope,
      scopedStudents,
      ...stats,
    }
  }

  makeStatsRequests = (product: LegacyProductRe, scope: StudentsScope, period: NormalizedInterval) => {
    const { studentEvents } = this
    return RSVP.hash({
      assessmentScores: studentEvents.assessmentScores(product, scope, period),
      awardsEarned: studentEvents.awardsEarned(product, scope, period),
      booksReadByGenre: studentEvents.booksReadByGenre(product, scope, period),
      courseProgressByGrade: studentEvents.courseProgressByGrade(product, 'reading', scope, period),
      lexileGrowth: studentEvents.lexileGrowth(product, scope, period),
      spellingCourseProgress: studentEvents.courseProgressByGrade(product, 'spelling', scope, period),
      storiesWritten: studentEvents.storiesWrittenByGrade(product, scope, period),
      skillsMastered: studentEvents.skillsMasteredRe(product, scope, period),
      totalUsageOverTime: studentEvents.totalUsageOverTime(product, scope, period),
    })
  }
}
